var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1090,
    height: 168,
    viewBox: "0 0 1090 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35929_58316)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 168,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_35929_58316)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 28,
    width: 110,
    height: 16,
    rx: 4,
    fill: "url(#paint1_linear_35929_58316)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 28,
    width: 51,
    height: 16,
    rx: 4,
    fill: "url(#paint2_linear_35929_58316)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 72,
    width: 529,
    height: 24,
    rx: 4,
    fill: "url(#paint3_linear_35929_58316)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 108,
    width: 1026,
    height: 12,
    rx: 4,
    fill: "url(#paint4_linear_35929_58316)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 132,
    width: 196,
    height: 12,
    rx: 4,
    fill: "url(#paint5_linear_35929_58316)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1089,
    height: 167,
    rx: 9.5,
    stroke: "#F4F4F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35929_58316",
    x1: 56,
    y1: 36.2105,
    x2: 32,
    y2: 36.2105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35929_58316",
    x1: 102,
    y1: 35.9999,
    x2: 191.714,
    y2: 35.9215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35929_58316",
    x1: 180,
    y1: 35.9999,
    x2: 252,
    y2: 35.9707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35929_58316",
    x1: 62,
    y1: 83.4994,
    x2: 572.462,
    y2: 83.6046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35929_58316",
    x1: 8.94382,
    y1: 114,
    x2: 1080.22,
    y2: 110.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35929_58316",
    x1: 55.8467,
    y1: 137.75,
    x2: 270,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35929_58316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 168,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostSkeleton);
export default __webpack_public_path__ + "static/media/post-skeleton.6999f001d5fd1f268bddb5133bd5d565.svg";
export { ForwardRef as ReactComponent };